import { create } from 'zustand';
import { EPresenterStep, IPresenterVisitStore } from './types';

export { EPresenterStep } from './types';

/**
 * Visit the Presenter is going through: its step, set by the dashboard and
 * shown by the stepper in the top panel, and its id, which changes on exit so
 * the dashboard drops everything entered and starts a new visit.
 */
export const usePresenterVisitStore = create<IPresenterVisitStore>((set) => ({
  step: EPresenterStep.SELECT_PATIENT,
  visitId: 0,
  setStep: (step) => set({ step }),
  exitVisit: () =>
    set(({ visitId }) => ({
      step: EPresenterStep.SELECT_PATIENT,
      visitId: visitId + 1,
    })),
  reset: () => set({ step: EPresenterStep.SELECT_PATIENT }),
}));
